import React, { useEffect, useMemo } from 'react';

import { Icons } from '~/assets';
import history from '~/config/history';
import { PATHS } from '~/routes/paths';

import { Container, Texto, Titulo } from './styles';

function AcionamentoExpirado() {
  const data = useMemo(() => history?.location?.state, []);

  useEffect(() => {
    if (!data) {
      history.replace(PATHS.loading);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <img src={Icons.Alert} alt='tempo expirado' style={{ margin: '0 auto 6.3rem' }} />

      <Titulo>O serviço foi expirado</Titulo>
      <Texto>
        A assistência{}
        <Texto isBold>{` ${data?.idAssistencia}/${data?.numServico} `}</Texto>
        esta expirada por inatividade, pois não recebemos retorno dentro do prazo.
        <br />
        <br />
        Por favor, entre em contato com a central de atendimento
        <br />
        no<Texto isBold>{` ${data?.clienteCorporativoTelefone} `}</Texto>
        <br />e informe o número da assistência para dar continuidade.
      </Texto>
    </Container>
  );
}

export default AcionamentoExpirado;
